import { StockOnHandSort } from "@saleor/stockOnHand/views/ReportStockOnHandPage/sort";
import { stringifyQs } from "@saleor/utils/urls";

export const stockOnHandUrl = "/stock-on-hand";

export const stockOnHandUrlParam = (params: StockOnHandSort) =>
  stockOnHandUrl + "?" + stringifyQs(params);
